import instance from '@/http/http.js';

//基金基本信息
function plateIndexDetail(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/plateIndexDetail',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//基金基本信息
function indexComponentList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/indexComponentList',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//k
function Kline(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/Kline',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//相关基金
function indexRelationFund(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/indexRelationFund',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//估值水平
function indexValuation(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/indexValuation',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//PE/PB
function indexPePbBand(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/indexPePbBand',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//回报率
function indexCapitalReturn(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/indexCapitalReturn',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//股息率
function indexDividendRate(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/indexDividendRate',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//利润率
function indexProfitMargin(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/indexProfitMargin',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

export {
  indexCapitalReturn,
  indexComponentList,
  indexDividendRate,
  indexPePbBand,
  indexProfitMargin,
  indexRelationFund,
  indexValuation,
  Kline,
  plateIndexDetail,
};